import { deleteRequest, get, post, put } from 'helpers/api';

export const SET_PLAYBOOKS = 'SET_PLAYBOOKS';
export function loadPlaybooks() {
  return async (dispatch, getState) => {
    const playbooks = await get(getState().paths.index);
    dispatch({ type: SET_PLAYBOOKS, playbooks });
  };
}

export const ADD_FIELD = 'ADD_FIELD';
export function createField(playbook, name, stage, required) {
  return async (dispatch) => {
    const field = await post(playbook.fieldsPath, { name, stage, required });
    dispatch(({ type: ADD_FIELD, playbook, field }));
  };
}

export const CHANGE_FIELD = 'CHANGE_FIELD';
export function changeField(playbook, field, changes) {
  return (dispatch) => {
    put(field.path, changes);
    dispatch({ type: CHANGE_FIELD, playbook, field, changes });
  };
}

export const DELETE_FIELD = 'DELETE_FIELD';
export function deleteField(playbook, field) {
  return (dispatch) => {
    deleteRequest(field.path);
    dispatch({ type: DELETE_FIELD, playbook, field });
  };
}

export const ADD_TASK = 'ADD_TASK';
export function createTask(playbook, newTask) {
  return async (dispatch, getState) => {
    const currentPlaybook = getState().playbooks.find(statePlaybook => statePlaybook.id === playbook.id);

    const tasks = currentPlaybook.tasksByStage[newTask.stage];
    const sortOrder = tasks.length === 0
      ? 0
      : Math.max(...tasks.map(task => task.sortOrder)) + 1;

    const task = await post(playbook.tasksPath, {
      ...newTask,
      sortOrder,
    });

    dispatch(({ type: ADD_TASK, playbook, task }));
  };
}

export const CHANGE_TASK = 'CHANGE_TASK';
export function changeTask(playbook, task, changes) {
  return { type: CHANGE_TASK, playbook, task, changes };
}

export const REPLACE_TASK = 'REPLACE_TASK';
export function updateTask(playbook, task, changes) {
  return async (dispatch) => {
    const updatedTask = await put(task.path, changes);
    dispatch({ type: REPLACE_TASK, playbook, task, updatedTask });
  };
}

export const DELETE_TASK = 'DELETE_TASK';
export function deleteTask(playbook, task) {
  return (dispatch) => {
    deleteRequest(task.path);
    dispatch({ type: DELETE_TASK, playbook, task });
  };
}

export const REORDER_TASKS = 'REORDER_TASKS';
export function reorderTasks(playbook, stage, sourceTaskId, targetTaskId) {
  return { type: REORDER_TASKS, playbook, stage, sourceTaskId, targetTaskId };
}

export function saveTaskOrdering(playbook, stage) {
  return async (dispatch, getState) => {
    playbook = getState().playbooks.find(statePlaybook => statePlaybook.id === playbook.id);

    const body = { tasks: [] };
    for (const [sortOrder, task] of playbook.tasksByStage[stage].entries()) {
      const changes = { sortOrder };
      body.tasks.push({ id: task.id, ...changes });
      dispatch(changeTask(playbook, task, changes));
    }

    put(playbook.tasksPath, body);
  };
}

export function copyTasks(tasks, dealType, stage, createTasks) {
  return async (dispatch, getState) => {
    const playbook = getState().playbooks.find(playbook => playbook.dealType === dealType);

    const errors = [];
    for (const task of tasks) {
      try {
        await dispatch(createTask(playbook, {
          ...task,
          assigneeId: task.assignee?.id,
          assignee: undefined,
          createTasks,
          stage,
        }));
      } catch (error) {
        errors.push(`Could not copy ${task.name}`);
      }
    }
    
    if (errors.length) {
      throw errors;
    }
  };
}
